export const INITIAL_APP_STATE = {
  appLoader: false,
  tralslationLoader: false,
  translatedText: "",
  languages: [],
};
